export default __webpack_public_path__ + "static/media/icon_c_order.b54bcd1c.svg";